import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  createPaymentReturns,
  getCustomerAddressList,
  getDeductionList,
  getDocumentSetList,
  getListCurrency,
  getListCustomerList,
  getListMainproduct,
  getTaxList,
  viewPaymentReturns,
  updatePaymentReturns,
  getWarehouseList,
  getPaymentMethodList,
  getCreditNotesList,
  getListCountry,
  getLanguageList,
  getMaturityDatesList,
  getProductPriceClassList,
  createListCustomer,
  getDeliveryMethodList,
  getListSalesmenList,
} from "../../services/MoloniServices";
import Select from "react-select";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { getCommonSearchList } from "../../services/settingsServices";

const AddPaymentReturns = () => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const { t } = useTranslation();
  const [btnLoader, setBtnLoader] = useState(false);
  const initialTax = { tax_id: 0, value: 0, order: 0, cumulative: 0 };
  const initialChildProduct = {
    product_id: 0,
    name: "",
    summary: "",
    qty: 0,
    price: 0,
    discount: 0,
    deduction_id: null,
    order: 0,
    exemption_reason: "",
    warehouse_id: null,
    taxes: [initialTax],
  };

  const initialProduct = {
    product_id: 0,
    name: "",
    summary: "",
    qty: 0,
    price: 0,
    discount: 0,
    deduction_id: null,
    order: 0,
    exemption_reason: "",
    warehouse_id: null,
    taxes: [initialTax],
  };

  const [customerData, setCustomerData] = useState({
    id: "",
    vat: "",
    number: "",
    name: "",
    language_id: "",
    qty_copies_document: "",
    notes: "",
    country_id: "",
    address: "",
    zip_code: "",
    city: "",
    email: "",
    website: "",
    phone: "",
    fax: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    discount: "",
    credit_limit: "",
    payment_method_id: "",
    delivery_method_id: "",
    maturity_date_id: "",
    field_notes: "",
    salesman_id: "",
    price_class_id: "",
    payment_day: "",
    document_type_id: "",
    moloni_id: "",
    contact_person: "",
    contact_notes: "",
    customer_iva: 0,
    series_id: "",
    price_id: "",
  });

  const [invoiceReceiptsData, setInvoiceReceiptsData] = useState({
    id: "",
    moloni_id: "",
    date: new Date().toISOString().split("T")[0],
    document_set_id: "",
    customer_id: "",
    alternate_address_id: "",
    products: [initialProduct],
    exchange_currency_id: "",
    exchange_rate: "",
    delivery_method_id: "",
    notes: "",
    status: 0,
    associated_documents: [],
    payments: [],
    associate_document_type: "",
    net_value: "",
    alternate_address: [],
    salesman_commission: "",
  });

  const [invoiceReceiptsViewData, setInvoiceReceiptsViewData] = useState("");
  let errorsObj = {
    date: "",
    document_set_id: "",
    customer_id: "",
    expiration_date: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [documentSetList, setDocumentSetList] = useState([]);
  const [customerList, seCustomerList] = useState([]);
  const [exchangeCurrList, setExchangeCurrList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [deductionList, setDeductionList] = useState([]);
  const [taxDataList, setTaxDataList] = useState([]);
  const [errorsPro, setErrorsPro] = useState({});
  const [selectedProduct, setSelectedProduct] = useState("");
  const [alternateAddressList, setAlternateAddressList] = useState([]);
  const [assocDataList, setAssocDataList] = useState([]);
  const [propertyErrors, setPropertyErrors] = useState([]);
  const [warehouseList, setWarehouseList] = useState([]);
  const [paymentErrors, setPaymentErrors] = useState([]);
  const [paymentList, setPaymentList] = useState([]);
  const [invoiceType, setInvoiceType] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [customerModel, setCustomerModel] = useState(false);
  const [activeCustomerTab, setActiveCustomerTab] = useState("1");
  const [filterList, seFilterList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [altForm, setAltForm] = useState({
    description: "",
    code: "",
    address: "",
    zip_code: "",
    city: "",
    country: "",
    email: "",
    phone: "",
    fax: "",
    contact_person: "",
  });
  const [languageList, setLanguageList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [maturityDatesList, setMaturityDatesList] = useState([]);
  const [priceClassList, setPriceClassList] = useState([]);
  const [salesmenList, setSalesmenDatesList] = useState([]);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [deliveryMethodList, setDeliveryMethodList] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [openFinancial, setOpenFinancial] = useState(false);
  const [openAssoDocument, setOpenAssoDocument] = useState(false);
  const [openPayment, setOpenPayment] = useState(false);
  const [openProduct, setOpenProduct] = useState(false);
  const [openNotes, setOpenNotes] = useState(false);
  const [exemptionList, setExemptionList] = useState([]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "exception_list",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].code,
            label: response.data[i].description,
          });
        }

        setExemptionList(list);
      })
      .catch((err) => {});
  }, []);

  const handleAltChange = (e) => {
    setAltForm({
      ...altForm,
      [e.target.name]: e.target.value,
    });
  };

  const resetAltForm = () => {
    setAltForm({
      description: "",
      code: "",
      address: "",
      zip_code: "",
      city: "",
      country: "",
      email: "",
      phone: "",
      fax: "",
      contact_person: "",
    });
    setEditIndex(null);
  };

  const editAlternateAddress = (index) => {
    setAltForm(invoiceReceiptsData.alternate_address[index]);
    setEditIndex(index);
  };

  const deleteAlternateAddress = (index) => {
    const updated = invoiceReceiptsData.alternate_address.filter(
      (_, i) => i !== index,
    );

    setInvoiceReceiptsData({
      ...invoiceReceiptsData,
      alternate_address: updated,
    });
  };

  const handleCustomerCloseModel = () => {
    setCustomerModel(false);
  };

  const saveAlternateAddress = () => {
    if (
      !altForm.description ||
      !altForm.code ||
      !altForm.address ||
      !altForm.zip_code ||
      !altForm.city ||
      !altForm.country
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    let updatedList = [...invoiceReceiptsData.alternate_address];

    if (editIndex !== null) {
      updatedList[editIndex] = altForm;
    } else {
      updatedList.push(altForm);
    }

    setInvoiceReceiptsData({
      ...invoiceReceiptsData,
      alternate_address: updatedList,
    });

    resetAltForm();
  };

  const validateProduct = (product, index) => {
    let newErrors = {};

    if (!product.product_id) newErrors.product_id = "Product is required";
    if (!product.name?.trim()) newErrors.name = "Name is required";
    if (!product.qty || product.qty <= 0)
      newErrors.qty = "Quantity is required";
    if (!product.price || product.price <= 0)
      newErrors.price = "Price is required";

    setErrorsPro((prev) => ({
      ...prev,
      [index]: newErrors,
    }));

    return Object.keys(newErrors).length === 0;
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  const handleSelectCustomer = (item) => {
    setSearch(item.name);
    setSelectedCustomerId(item.moloni_id);
  };

  const handleAddProduct = (e) => {
    e.preventDefault();

    let list = [...invoiceReceiptsData.products];
    list.push({ ...initialProduct });

    setInvoiceReceiptsData({
      ...invoiceReceiptsData,
      products: list,
    });
  };

  const handleRemoveProduct = (e, index) => {
    e.preventDefault();

    let list = [...invoiceReceiptsData.products];
    list.splice(index, 1);

    setInvoiceReceiptsData({
      ...invoiceReceiptsData,
      products: list,
    });
  };

  const handleAddChildProduct = (e, productIndex) => {
    e.preventDefault();
    let list = [...invoiceReceiptsData.products];
    if (!list[productIndex].child_products) {
      list[productIndex].child_products = [];
    }
    list[productIndex].child_products.push({ ...initialChildProduct });
    setInvoiceReceiptsData({ ...invoiceReceiptsData, products: list });
  };

  const handleRemoveChildProduct = (e, productIndex, childIndex) => {
    e.preventDefault();
    let list = [...invoiceReceiptsData.products];
    list[productIndex].child_products.splice(childIndex, 1);
    setInvoiceReceiptsData({ ...invoiceReceiptsData, products: list });
  };

  const handleAddChildProperty = (e, productIndex, childIndex) => {
    e.preventDefault();

    let list = [...invoiceReceiptsData.products];

    if (!list[productIndex].child_products[childIndex].properties) {
      list[productIndex].child_products[childIndex].properties = [];
    }

    list[productIndex].child_products[childIndex].properties.push({
      title: "",
      value: "",
    });

    setInvoiceReceiptsData({
      ...invoiceReceiptsData,
      products: list,
    });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListSalesmenList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setSalesmenDatesList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDeliveryMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDeliveryMethodList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getProductPriceClassList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].title,
          });
        }

        setPriceClassList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getPaymentMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setPaymentMethodList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getMaturityDatesList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setMaturityDatesList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getLanguageList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].language_id,
            label: response.data[i].title,
          });
        }

        setLanguageList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setCountryList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 10,
      page: 1,
      search: "",
      type: "m_payment_return",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setInvoiceType(list);
      })
      .catch((err) => {});
  }, []);

  const handleAddChildTax = (e, productIndex, childIndex) => {
    e.preventDefault();

    let list = [...invoiceReceiptsData.products];

    if (!list[productIndex].child_products[childIndex].taxes) {
      list[productIndex].child_products[childIndex].taxes = [];
    }

    list[productIndex].child_products[childIndex].taxes.push({
      tax_id: null,
      value: 0,
      order: null,
      cumulative: 0,
    });

    setInvoiceReceiptsData({
      ...invoiceReceiptsData,
      products: list,
    });
  };

  const handleAddTax = (e, productIndex) => {
    e.preventDefault();

    let list = [...invoiceReceiptsData.products];
    list[productIndex].taxes.push({ ...initialTax });

    setInvoiceReceiptsData({
      ...invoiceReceiptsData,
      products: list,
    });
  };

  const handleRemoveTax = (e, productIndex, taxIndex) => {
    e.preventDefault();

    let list = [...invoiceReceiptsData.products];
    list[productIndex].taxes.splice(taxIndex, 1);

    setInvoiceReceiptsData({
      ...invoiceReceiptsData,
      products: list,
    });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getWarehouseList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].title,
          });
        }

        setWarehouseList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (uuid) {
      let data = { id: uuid };
      viewPaymentReturns(data)
        .then((response) => {
          setInvoiceReceiptsViewData(response.data.data);
        })
        .catch((err) => {
          navigate("/estimates");
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [uuid]);

  useEffect(() => {
    if (invoiceReceiptsViewData) {
      setInvoiceReceiptsData({
        id: invoiceReceiptsViewData?.id,
        date: invoiceReceiptsViewData?.date,
        document_set_id: invoiceReceiptsViewData?.document_set_id,
        customer_id: invoiceReceiptsViewData?.customer_id,
        alternate_address_id: invoiceReceiptsViewData?.alternate_address_id,
        products: invoiceReceiptsViewData?.products,
        exchange_currency_id: invoiceReceiptsViewData?.exchange_currency_id,
        exchange_rate: invoiceReceiptsViewData?.exchange_rate,
        notes: invoiceReceiptsViewData?.notes,
        status: invoiceReceiptsViewData?.status,
        associated_documents: invoiceReceiptsViewData?.associated_documents,
        payments: invoiceReceiptsViewData?.payments,
        net_value: invoiceReceiptsViewData?.net_value,
        salesman_commission: invoiceReceiptsViewData?.salesman_commission,
      });
    }
  }, [invoiceReceiptsViewData]);

  const handleAddAssociatedDocuments = () => {
    setInvoiceReceiptsData((prev) => {
      const lastAssociatedDocuments =
        prev.associated_documents[prev.associated_documents?.length - 1];

      if (!lastAssociatedDocuments) {
        return {
          ...prev,
          associated_documents: [{ associated_id: "", value: "" }],
        };
      }

      if (
        !lastAssociatedDocuments.associated_id ||
        !lastAssociatedDocuments.value
      ) {
        toast.error(
          "Please complete associate,value before adding another associated documents",
        );
        return prev;
      }

      return {
        ...prev,
        associated_documents: [
          ...prev.associated_documents,
          { associated_id: "", value: "" },
        ],
      };
    });
  };

  const handleRemoveAssociatedDocuments = (index) => {
    setInvoiceReceiptsData((prev) => ({
      ...prev,
      associated_documents: prev.associated_documents.filter(
        (_, i) => i !== index,
      ),
    }));
  };

  const handleChangeAssociatedDocuments = (index, field, value) => {
    setInvoiceReceiptsData((prev) => {
      const updatedDocs = [...prev.associated_documents];

      if (field === "associated_id") {
        updatedDocs[index][field] = value;

        const selectedDoc = assocDataList.find((doc) => doc.value === value);

        if (selectedDoc && selectedDoc.net_value) {
          updatedDocs[index].value = selectedDoc.net_value;
        }
      } else {
        updatedDocs[index][field] = value;
      }

      return { ...prev, associated_documents: updatedDocs };
    });

    setPropertyErrors((prevErrors) => {
      const errors = [...prevErrors];
      errors[index] = errors[index] || {};

      if (field === "associated_id" && !value) {
        errors[index].associated_id = "Associated is required";
      } else if (field === "associated_id") {
        errors[index].associated_id = "";
      }

      if (field === "value" && !value) {
        errors[index].value = "Value is required";
      } else if (field === "value") {
        errors[index].value = "";
      }

      return errors;
    });
  };

  const handleAddPayments = () => {
    setInvoiceReceiptsData((prev) => {
      const lastPayments = prev.payments[prev.payments?.length - 1];

      if (!lastPayments) {
        return {
          ...prev,
          payments: [{ payment_method_id: "", date: "", value: "", notes: "" }],
        };
      }

      if (
        !lastPayments.payment_method_id ||
        !lastPayments.value ||
        !lastPayments.date
      ) {
        toast.error(
          "Please complete payment method,value date, before adding another payment.",
        );
        return prev;
      }

      return {
        ...prev,
        payments: [
          ...prev.payments,
          { payment_method_id: "", date: "", value: "" },
        ],
      };
    });
  };

  const handleRemovePayments = (index) => {
    setInvoiceReceiptsData((prev) => ({
      ...prev,
      payments: prev.payments.filter((_, i) => i !== index),
    }));
  };

  const handleChangePayments = (index, field, value) => {
    setInvoiceReceiptsData((prev) => {
      const updatedDocs = [...prev.payments];

      if (field === "payment_method_id") {
        updatedDocs[index][field] = value;

        const selectedDoc = assocDataList.find((doc) => doc.value === value);

        if (selectedDoc && selectedDoc.net_value) {
          updatedDocs[index].value = selectedDoc.net_value;
        }
      } else {
        updatedDocs[index][field] = value;
      }

      return { ...prev, payments: updatedDocs };
    });

    setPaymentErrors((prevErrors) => {
      const errors = [...prevErrors];
      errors[index] = errors[index] || {};

      if (field === "payment_method_id" && !value) {
        errors[index].associated_id = "Payment Method is required";
      } else if (field === "payment_method_id") {
        errors[index].payment_method_id = "";
      }

      if (field === "value" && !value) {
        errors[index].value = "Value is required";
      } else if (field === "value") {
        errors[index].value = "";
      }

      if (field === "date" && !value) {
        errors[index].date = "Date is required";
      } else if (field === "date") {
        errors[index].date = "";
      }

      return errors;
    });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getPaymentMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setPaymentList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (!selectedCustomerId) {
      return;
    }

    if (Number(invoiceReceiptsData.associate_document_type) === 1) {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        customer_id: selectedCustomerId,
      };

      getCreditNotesList(data)
        .then((response) => {
          let list = response.data.data.map((item) => ({
            value: item.document_id,
            label: `${item.entity_name} (${item.number})`,
            net_value: item.net_value,
            customer_id: item.customer_id,
          }));
          setAssocDataList(list);
        })
        .catch((err) => toast.error(Utils.getErrorMessage(err)));
    }
  }, [invoiceReceiptsData, invoiceReceiptsData?.associate_document_type]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDeductionList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDeductionList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListMainproduct(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
            price: response.data[i].price,
            stock: response.data[i].stock,
            exemption_reason: response.data[i].exemption_reason,
            taxes: response.data[i].taxes,
            properties: response.data[i].properties,
            warehouse: response.data[i].warehouse,
          });
        }

        setProductList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (selectedProduct) {
      const initialProduct = {
        product_id: selectedProduct?.value,
        name: selectedProduct.label || "",
        summary: "",
        qty: selectedProduct.stock || 0,
        price: selectedProduct.price || 0,
        discount: 0,
        deduction_id: "",
        order: 0,
        exemption_reason: "",
        warehouse_id: selectedProduct.warehouse,
        properties: selectedProduct.properties || [],
        taxes: selectedProduct.taxes || [],
      };

      setInvoiceReceiptsData((prev) => ({
        ...prev,
        products: [initialProduct],
      }));
    }
  }, [selectedProduct]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getTaxList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setTaxDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(
    function () {
      if (selectedCustomerId) {
        let data = {
          limit: 20,
          page: 1,
          search: "",
          customer_id: selectedCustomerId,
        };
        getCustomerAddressList(data)
          .then((res) => {
            const response = res.data.address;

            let list = [];
            for (let i = 0; i < response.length; i++) {
              list.push({
                value: response[i].moloni_id,
                label: response[i].name,
              });
            }

            setAlternateAddressList(list);
          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
          });
      }
    },
    [invoiceReceiptsData],
  );

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCurrency(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setExchangeCurrList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(
    function () {
      let data = {
        limit: 20,
        page: 1,
        search: search ? search : "",
      };
      getListCustomerList(data)
        .then((response) => {
          seCustomerList(response.data.data);
          if (search) {
            seFilterList(response.data.data);
          }
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    },
    [search],
  );

  const handleSubmit = (e) => {
    e.preventDefault();

    setBtnLoader(true);

    let error = false;
    let errorObj = { ...errorsObj };
    if (!invoiceReceiptsData?.date) {
      errorObj.date = `Date is required.`;
      error = true;
      setBtnLoader(false);
    }

    // if (!invoiceReceiptsData.expiration_date) {
    //   errorObj.expiration_date = `Expiration Date is required.`;
    //   error = true;
    //   setBtnLoader(false);
    // }

    // if (invoiceReceiptsData?.date && invoiceReceiptsData?.expiration_date) {
    //   const start = new Date(invoiceReceiptsData.date);
    //   const end = new Date(invoiceReceiptsData.expiration_date);

    //   if (end < start) {
    //     errorObj.expiration_date = "Expiration Date must be after Date.";
    //     error = true;
    //   }
    // }

    if (!invoiceReceiptsData.document_set_id) {
      errorObj.document_set_id = `Document Set is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!selectedCustomerId) {
      errorObj.customer_id = `Customer is required.`;
      error = true;
      setBtnLoader(false);
    }

    invoiceReceiptsData?.payments?.forEach((item, index) => {
      let rowError = {};

      if (!item.payment_method_id) {
        rowError.payment_method_id = "Payment Method is required.";
        error = true;
        setOpenPayment(true);
      }
      if (!item.value) {
        rowError.value = "Value is required.";
        error = true;
        setOpenPayment(true);
      }

      if (!item.date) {
        rowError.date = "Date is required.";
        error = true;
        setOpenPayment(true);
      }

      setBtnLoader(false);

      paymentErrors[index] = rowError;
    });

    let allValid = true;
    invoiceReceiptsData?.products.forEach((product, i) => {
      if (!validateProduct(product, i)) {
        allValid = false;
      }
    });

    if (!allValid) {
      toast.error("Product is Required");
      return;
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    let data = {
      date: invoiceReceiptsData?.date,
      document_set_id: invoiceReceiptsData?.document_set_id,
      customer_id: selectedCustomerId,
      alternate_address_id: invoiceReceiptsData?.alternate_address_id,
      products: invoiceReceiptsData?.products,
      notes: invoiceReceiptsData?.notes,
      status: invoiceReceiptsData?.status,
      associated_documents: invoiceReceiptsData?.associated_documents,
      payments: invoiceReceiptsData?.payments,
      exchange_rate: invoiceReceiptsData?.exchange_rate,
      exchange_currency_id: invoiceReceiptsData?.exchange_currency_id,
      net_value: invoiceReceiptsData?.net_value,
      salesman_commission: invoiceReceiptsData?.salesman_commission,
    };

    let updateData = {
      id: invoiceReceiptsData?.id,
      document_id: invoiceReceiptsViewData?.document_id,
      date: invoiceReceiptsData?.date,
      document_set_id: invoiceReceiptsData?.document_set_id,
      customer_id: selectedCustomerId,
      alternate_address_id: invoiceReceiptsData?.alternate_address_id,
      special_discount: invoiceReceiptsData?.special_discount,
      products: invoiceReceiptsData?.products,
      notes: invoiceReceiptsData?.notes,
      status: invoiceReceiptsData?.status,
      associated_documents: invoiceReceiptsData?.associated_documents,
      payments: invoiceReceiptsData?.payments,
      exchange_rate: invoiceReceiptsData?.exchange_rate,
      exchange_currency_id: invoiceReceiptsData?.exchange_currency_id,
      net_value: invoiceReceiptsData?.net_value,
      salesman_commission: invoiceReceiptsData?.salesman_commission,
    };

    if (invoiceReceiptsViewData?.id) {
      updatePaymentReturns(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/paymentReturns");
          setInvoiceReceiptsData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
            payments: [],
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    } else {
      createPaymentReturns(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/paymentReturns");
          setInvoiceReceiptsData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
            payments: [],
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    }
  };

  const handleCustomerSubmit = (e) => {
    e.preventDefault();

    if (!customerData.vat) {
      toast.error("Vat is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.number) {
      toast.error("Number is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.name) {
      toast.error("Name is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.language_id) {
      setActiveCustomerTab("4");
      toast.error("Language is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.address) {
      toast.error("Address is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.city) {
      toast.error("City is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.zip_code) {
      toast.error("Zip Code is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.country_id) {
      toast.error("Country is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.email) {
      toast.error("Email is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.maturity_date_id) {
      toast.error("Maturity Date is required.");
      setActiveCustomerTab("4");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.payment_method_id) {
      toast.error("Payment Method is required.");
      setActiveCustomerTab("4");
      setIsModifyButtonLoad(false);
      return;
    }

    let data = {
      company_id: "269134",
      vat: customerData?.vat,
      number: customerData?.number,
      name: customerData?.name,
      language_id: customerData?.language_id,
      qty_copies_document: customerData?.qty_copies_document,
      notes: customerData?.notes,
      country_id: customerData?.country_id,
      address: customerData?.address,
      zip_code: customerData?.zip_code,
      city: customerData?.city,
      email: customerData?.email,
      website: customerData?.website,
      phone: customerData?.phone,
      fax: customerData?.fax,
      contact_name: customerData?.contact_name,
      contact_email: customerData?.contact_email,
      contact_phone: customerData?.contact_phone,
      discount: customerData?.discount,
      credit_limit: customerData?.credit_limit,
      payment_method_id: customerData?.payment_method_id,
      delivery_method_id: customerData?.delivery_method_id,
      maturity_date_id: customerData?.maturity_date_id,
      field_notes: customerData?.field_notes,
      salesman_id: customerData?.salesman_id,
      price_class_id: customerData?.price_class_id,
      payment_day: customerData?.payment_day,
      document_type_id: 0,
    };

    createListCustomer(data)
      .then((response) => {
        toast.success(response.data.message);

        setIsModifyButtonLoad(false);
        setCustomerData({
          id: "",
          vat: "",
          number: "",
          name: "",
          language_id: "",
          qty_copies_document: "",
          notes: "",
          country_id: "",
          address: "",
          zip_code: "",
          city: "",
          email: "",
          website: "",
          phone: "",
          fax: "",
          contact_name: "",
          contact_email: "",
          contact_phone: "",
          discount: "",
          credit_limit: "",
          payment_method_id: "",
          delivery_method_id: "",
          maturity_date_id: "",
          field_notes: "",
          salesman_id: "",
          price_class_id: "",
          payment_day: "",
          document_type_id: "",
          moloni_id: "",
        });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsModifyButtonLoad(false);
      });
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid container-custom-height-new">
            <div className="row mb-2">
              <div className="col-sm-12 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-document")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
                <h1 className="page-title ms-auto mb-2">
                  {t("paymentReturns")}
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="row justify-content-start">
              <div className="col-md-12">
                <Form method={`post`} onSubmit={handleSubmit}>
                  <div className="card card-primary">
                    {/* <h5 className="page-title">Payment Return</h5>
                    <h5 className="page-title">
                      {uuid
                        ? `In this section you can change the payment retun`
                        : "Create Payment Return"}
                    </h5> */}
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("date")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="date"
                                  value={invoiceReceiptsData.date}
                                  onChange={(e) => {
                                    setInvoiceReceiptsData({
                                      ...invoiceReceiptsData,
                                      date: e.target.value,
                                    });
                                  }}
                                  name="date"
                                  placeholder="Select Date"
                                />
                              </div>
                              {errors.date && (
                                <span className="input-error">
                                  {errors.date}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("documentSet")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={documentSetList}
                                  value={documentSetList.find(
                                    (item) =>
                                      item.value ===
                                      invoiceReceiptsData.document_set_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setInvoiceReceiptsData({
                                      ...invoiceReceiptsData,
                                      document_set_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Document Set"}
                                />
                                {errors.document_set_id && (
                                  <span className="input-error">
                                    {errors.document_set_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="row">
                          <div
                            className="card"
                            style={{
                              padding: "0px",
                              marginLeft: "15px",
                            }}
                          >
                            <div
                              className="card-header"
                              style={{
                                background: "#81bb42",
                                fontWeight: "600",
                              }}
                            >
                              {t("customers")}
                            </div>
                            <div className="card-body">
                              <div className="row">
                                <div
                                  className="col-md-9 position-relative"
                                  style={{
                                    padding: "15px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    className="form-control pe-5"
                                    placeholder="Customers Search"
                                    value={search}
                                    onChange={(e) =>
                                      handleSearch(e.target.value)
                                    }
                                  />
                                  {search && (
                                    <i
                                      className="bi bi-x-circle-fill text-muted"
                                      style={{
                                        position: "absolute",
                                        right: "20px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => handleSearch("")}
                                    ></i>
                                  )}
                                </div>

                                <div className="col-md-2 mt-3">
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => setCustomerModel(true)}
                                  >
                                    {t("createCustomer")}{" "}
                                    <i className="bi bi-check2"></i>
                                  </button>
                                </div>

                                {filterList?.length > 0 && (
                                  <table className="table table-bordered mt-2">
                                    <thead>
                                      <tr>
                                        <th>Code</th>
                                        <th>Name</th>
                                        <th>Address</th>
                                        <th>VAT Number</th>
                                        <th>Product Price Table</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {filterList?.map((item, index) => (
                                        <tr
                                          key={index}
                                          style={{ cursor: "pointer" }}
                                          className={
                                            selectedCustomerId ===
                                            item.moloni_id
                                              ? "table-active"
                                              : ""
                                          }
                                          onClick={() =>
                                            handleSelectCustomer(item)
                                          }
                                        >
                                          <td>{item.moloni_id}</td>
                                          <td>{item.name}</td>
                                          <td>{item.address}</td>
                                          <td>{item.vat}</td>
                                          <td>
                                            {item.price_class_name || "-"}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="section-box mt-3">
                        <div
                          className={`section-header-green ${
                            openFinancial ? "active" : ""
                          }`}
                          onClick={() => setOpenFinancial(!openFinancial)}
                        >
                          <i
                            className={`bi ${
                              openFinancial
                                ? "bi-chevron-up"
                                : "bi-chevron-down"
                            }`}
                          ></i>
                          <span className="ms-2">Financial Data</span>
                        </div>
                        <div
                          className={`collapse ${openFinancial ? "show" : ""}`}
                        >
                          <div className="row mt-3">
                            <div className="col-md-6">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("commission")}(%)
                                </Label>
                                <input
                                  className="form-control"
                                  type="number"
                                  value={
                                    invoiceReceiptsData.salesman_commission
                                  }
                                  onChange={(e) => {
                                    setInvoiceReceiptsData({
                                      ...invoiceReceiptsData,
                                      salesman_commission: e.target.value,
                                    });
                                  }}
                                  name="salesman_commission"
                                  placeholder="Commission"
                                />
                              </FormGroup>
                            </div>

                            <div className="col-md-6">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("exchange_currency")}
                                </Label>
                                <Select
                                  className="my-select-v"
                                  options={exchangeCurrList}
                                  value={exchangeCurrList.find(
                                    (item) =>
                                      item.value ===
                                      invoiceReceiptsData.exchange_currency_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setInvoiceReceiptsData({
                                      ...invoiceReceiptsData,
                                      exchange_currency_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Exchange Currency"}
                                />
                              </FormGroup>
                            </div>

                            <div className="col-md-6">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("exchange_rate")}
                                </Label>
                                <input
                                  className="form-control"
                                  type="number"
                                  value={invoiceReceiptsData.exchange_rate}
                                  onChange={(e) => {
                                    setInvoiceReceiptsData({
                                      ...invoiceReceiptsData,
                                      exchange_rate: e.target.value,
                                    });
                                  }}
                                  name="exchange_rate"
                                  placeholder="Exchange Rate"
                                />
                              </FormGroup>
                            </div>
                            <div className="col-md-6">
                              <div className="col-md-6">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("net_value")}
                                  </Label>
                                  <input
                                    className="form-control"
                                    type="number"
                                    value={invoiceReceiptsData.net_value}
                                    onChange={(e) => {
                                      setInvoiceReceiptsData({
                                        ...invoiceReceiptsData,
                                        net_value: e.target.value,
                                      });
                                    }}
                                    name="net_value"
                                    placeholder="Net Value"
                                  />
                                </FormGroup>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="section-box">
                        <div
                          className={`section-header-green ${
                            openAssoDocument ? "active" : ""
                          }`}
                          onClick={() => setOpenAssoDocument(!openAssoDocument)}
                        >
                          <i
                            className={`bi ${
                              openAssoDocument
                                ? "bi-chevron-up"
                                : "bi-chevron-down"
                            }`}
                          ></i>
                          <span className="ms-2">
                            {t("associated_documents")}
                          </span>
                        </div>

                        <div
                          className={`collapse ${
                            openAssoDocument ? "show" : ""
                          }`}
                        >
                          <div className="row mt-3">
                            <div className="col-md-6">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("associate_document_type")}
                                </Label>
                                <Select
                                  className="my-select-v"
                                  options={invoiceType}
                                  value={invoiceType.find(
                                    (item) =>
                                      item.value ===
                                      invoiceReceiptsData.associate_document_type,
                                  )}
                                  onChange={(selectedOption) => {
                                    setInvoiceReceiptsData({
                                      ...invoiceReceiptsData,
                                      associate_document_type: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Document type"}
                                />
                              </FormGroup>
                            </div>
                            <div className="col-md-6 mt-5">
                              <button
                                className="btn btn-primary"
                                onClick={handleAddAssociatedDocuments}
                                type="button"
                              >
                                + {t("add")}
                              </button>
                            </div>
                            {invoiceReceiptsData?.associated_documents?.length >
                            0 ? (
                              <div
                                className="row justify-content-start"
                                style={{
                                  maxHeight: "300px",
                                  overflowY: "auto",
                                }}
                              >
                                {invoiceReceiptsData?.associated_documents?.map(
                                  (tax, index) => (
                                    <div className="col-md-6">
                                      <div className="fileupload-content px-4">
                                        <div
                                          className="row justify-content-start align-items-center mb-2"
                                          key={index}
                                        >
                                          <div className="col-md-6">
                                            <FormGroup>
                                              <Label className="col-form-label form-label">
                                                {t("associated_documents")}
                                              </Label>
                                              <div className="col-xl-12">
                                                <div className="input-div">
                                                  <Select
                                                    className="my-select-v"
                                                    options={assocDataList}
                                                    value={
                                                      assocDataList.find(
                                                        (item) =>
                                                          item.value ===
                                                          tax.associated_id,
                                                      ) || null
                                                    }
                                                    onChange={(
                                                      selectedOption,
                                                    ) => {
                                                      handleChangeAssociatedDocuments(
                                                        index,
                                                        "associated_id",
                                                        selectedOption
                                                          ? selectedOption.value
                                                          : "",
                                                      );
                                                    }}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    placeholder={
                                                      "Select Associate"
                                                    }
                                                  />
                                                  {propertyErrors[index]
                                                    ?.associated_id && (
                                                    <small className="text-danger">
                                                      {
                                                        propertyErrors[index]
                                                          .associated_id
                                                      }
                                                    </small>
                                                  )}
                                                </div>
                                              </div>
                                            </FormGroup>
                                          </div>

                                          <div className="col-md-6">
                                            <FormGroup>
                                              <Label className="Label-my">
                                                {t("value")}
                                              </Label>
                                              <div className="col-xl-12">
                                                <input
                                                  className="form-control"
                                                  type="number"
                                                  value={tax.value}
                                                  onChange={(e) =>
                                                    handleChangeAssociatedDocuments(
                                                      index,
                                                      "value",
                                                      e.target.value,
                                                    )
                                                  }
                                                  placeholder="Value"
                                                />
                                                {propertyErrors[index]
                                                  ?.value && (
                                                  <small className="text-danger">
                                                    {
                                                      propertyErrors[index]
                                                        .value
                                                    }
                                                  </small>
                                                )}
                                              </div>
                                            </FormGroup>
                                          </div>

                                          <div className="d-flex align-items-center">
                                            <button
                                              className="btn btn-danger trash-btn-custom btn-sm ml-2"
                                              onClick={() =>
                                                handleRemoveAssociatedDocuments(
                                                  index,
                                                  tax,
                                                )
                                              }
                                              type="button"
                                            >
                                              <i className="bi bi-trash"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ),
                                )}
                              </div>
                            ) : (
                              <p className="text-muted">
                                No Associated documents list added.
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="section-box">
                        <div
                          className={`section-header-green ${
                            openPayment ? "active" : ""
                          }`}
                          onClick={() => setOpenPayment(!openPayment)}
                        >
                          <i
                            className={`bi ${
                              openPayment ? "bi-chevron-up" : "bi-chevron-down"
                            }`}
                          ></i>
                          <span className="ms-2">{t("payments")}</span>
                        </div>

                        <div
                          className={`collapse ${openPayment ? "show" : ""}`}
                        >
                          <div className="card mt-3 shadow-sm">
                            <div className="card-header d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Insert Payment Methods</h6>

                              <button
                                className="btn btn-primary btn-sm"
                                onClick={handleAddPayments}
                                type="button"
                              >
                                <i className="bi bi-plus-lg me-1"></i> Add
                                Payment
                              </button>
                            </div>

                            <div className="card-body">
                              {invoiceReceiptsData?.payments?.length > 0 ? (
                                <>
                                  {/* Table Header */}
                                  <div className="row fw-bold text-secondary border-bottom pb-2 mb-2">
                                    <div className="col-md-3">
                                      Payment Method
                                    </div>
                                    <div className="col-md-2">Date</div>
                                    <div className="col-md-2">Value</div>
                                    <div className="col-md-4">Notes</div>
                                    <div className="col-md-1 text-end">
                                      Action
                                    </div>
                                  </div>

                                  {/* Payment Rows */}
                                  {invoiceReceiptsData?.payments?.map(
                                    (p, index) => (
                                      <div
                                        key={index}
                                        className="row align-items-start mb-3 py-2 border rounded bg-light"
                                      >
                                        {/* Payment Method */}
                                        <div className="col-md-3">
                                          <Select
                                            className="my-select-v"
                                            options={paymentList}
                                            value={
                                              paymentList.find(
                                                (item) =>
                                                  item.value ===
                                                  p.payment_method_id,
                                              ) || null
                                            }
                                            onChange={(opt) =>
                                              handleChangePayments(
                                                index,
                                                "payment_method_id",
                                                opt ? opt.value : "",
                                              )
                                            }
                                            placeholder="Choose an option"
                                            isClearable
                                          />
                                          {paymentErrors[index]
                                            ?.payment_method_id && (
                                            <small className="text-danger">
                                              {
                                                paymentErrors[index]
                                                  .payment_method_id
                                              }
                                            </small>
                                          )}
                                        </div>

                                        {/* Date */}
                                        <div className="col-md-2">
                                          <input
                                            type="date"
                                            className="form-control"
                                            value={p.date}
                                            onChange={(e) =>
                                              handleChangePayments(
                                                index,
                                                "date",
                                                e.target.value,
                                              )
                                            }
                                          />
                                          {paymentErrors[index]?.date && (
                                            <small className="text-danger">
                                              {paymentErrors[index].date}
                                            </small>
                                          )}
                                        </div>

                                        {/* Value */}
                                        <div className="col-md-2 d-flex align-items-center">
                                          <input
                                            type="number"
                                            className="form-control"
                                            value={p.value}
                                            onChange={(e) =>
                                              handleChangePayments(
                                                index,
                                                "value",
                                                e.target.value,
                                              )
                                            }
                                          />
                                          <span className="ms-2">€</span>
                                          {paymentErrors[index]?.value && (
                                            <small className="text-danger d-block">
                                              {paymentErrors[index].value}
                                            </small>
                                          )}
                                        </div>

                                        {/* Notes */}
                                        <div className="col-md-4">
                                          <textarea
                                            className="form-control"
                                            rows={1}
                                            value={p.notes}
                                            onChange={(e) =>
                                              handleChangePayments(
                                                index,
                                                "notes",
                                                e.target.value,
                                              )
                                            }
                                            placeholder="Insert notes"
                                          />
                                        </div>

                                        {/* Delete */}
                                        <div className="col-md-1 text-end">
                                          <button
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={() =>
                                              handleRemovePayments(index)
                                            }
                                          >
                                            <i className="bi bi-trash"></i>
                                          </button>
                                        </div>
                                      </div>
                                    ),
                                  )}
                                </>
                              ) : (
                                <div className="alert alert-info mb-0">
                                  <i className="bi bi-info-circle me-2"></i> No
                                  payment list added.
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="section-box">
                        <div
                          className={`section-header-green ${
                            openNotes ? "active" : ""
                          }`}
                          onClick={() => setOpenNotes(!openNotes)}
                        >
                          <i
                            className={`bi ${
                              openNotes ? "bi-chevron-up" : "bi-chevron-down"
                            }`}
                          ></i>
                          <span className="ms-2">Notes</span>
                        </div>

                        <div className={`collapse ${openNotes ? "show" : ""}`}>
                          <div className="row mt-3">
                            <div className="col-md-6 mb-3">
                              <FormGroup>
                                <Label className="Label-my">{t("notes")}</Label>
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={invoiceReceiptsData.notes}
                                  onChange={(e) => {
                                    setInvoiceReceiptsData({
                                      ...invoiceReceiptsData,
                                      notes: e.target.value,
                                    });
                                  }}
                                  name="notes"
                                  placeholder="Notes"
                                  rows={3}
                                />
                              </FormGroup>
                            </div>

                            <div className="col-md-6 mb-3">
                              <FormGroup>
                                <Label className="Label-my">
                                  {t("status")}
                                </Label>
                                <div className="form-check">
                                  <input
                                    className="my-checkbox-1 form-check-input"
                                    type="checkbox"
                                    checked={invoiceReceiptsData.status === 1}
                                    onChange={(e) => {
                                      setInvoiceReceiptsData({
                                        ...invoiceReceiptsData,
                                        status: e.target.checked ? 1 : 0,
                                      });
                                    }}
                                  />
                                  <label className="form-check-label pl-2">
                                    {t("status")}
                                  </label>
                                </div>
                              </FormGroup>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card card-primary">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{
                              marginTop: "15px",
                              marginBottom: "15px",
                            }}
                          >
                            {" "}
                            <h5>{t("products")}</h5>
                            <button
                              className="btn btn-primary"
                              onClick={handleAddProduct}
                              type="button"
                            >
                              + {t("add_product")}
                            </button>
                          </div>

                          {invoiceReceiptsData?.products?.map((product, i) => (
                            <div key={i} className="card p-3 mb-3">
                              <h5>Product {i + 1}</h5>
                              <div className="row">
                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("product")}
                                    </Label>
                                    <Select
                                      className="my-select-v"
                                      options={productList}
                                      value={productList.find(
                                        (item) =>
                                          item.value ===
                                          String(
                                            invoiceReceiptsData.products[i]
                                              .product_id,
                                          ),
                                      )}
                                      onChange={(selectedOption) => {
                                        let list = [
                                          ...invoiceReceiptsData.products,
                                        ];
                                        list[i].product_id = selectedOption
                                          ? selectedOption.value
                                          : null;
                                        setInvoiceReceiptsData({
                                          ...invoiceReceiptsData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i); // validation
                                        setSelectedProduct(selectedOption);
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Product"}
                                    />
                                    {errorsPro[i]?.product_id && (
                                      <small className="text-danger">
                                        {errorsPro[i].product_id}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>
                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("name")}
                                    </Label>
                                    <input
                                      type="text"
                                      className="form-control mb-2"
                                      placeholder="Name"
                                      value={product.name}
                                      onChange={(e) => {
                                        let list = [
                                          ...invoiceReceiptsData.products,
                                        ];
                                        list[i].name = e.target.value;
                                        setInvoiceReceiptsData({
                                          ...invoiceReceiptsData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i); //validation
                                      }}
                                    />
                                    {errorsPro[i]?.name && (
                                      <small className="text-danger">
                                        {errorsPro[i].name}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("summary")}
                                    </Label>
                                    <input
                                      type="text"
                                      className="form-control mb-2"
                                      placeholder="Summary"
                                      value={product.summary}
                                      onChange={(e) => {
                                        let list = [
                                          ...invoiceReceiptsData.products,
                                        ];
                                        list[i].summary = e.target.value;
                                        setInvoiceReceiptsData({
                                          ...invoiceReceiptsData,
                                          products: list,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("quantity")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Quantity"
                                      value={product.qty}
                                      onChange={(e) => {
                                        let list = [
                                          ...invoiceReceiptsData.products,
                                        ];
                                        list[i].qty = parseFloat(
                                          e.target.value,
                                        );
                                        setInvoiceReceiptsData({
                                          ...invoiceReceiptsData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i);
                                      }}
                                    />
                                    {errorsPro[i]?.qty && (
                                      <small className="text-danger">
                                        {errorsPro[i].qty}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("price")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Price"
                                      value={product.price}
                                      onChange={(e) => {
                                        let list = [
                                          ...invoiceReceiptsData.products,
                                        ];
                                        list[i].price = parseFloat(
                                          e.target.value,
                                        );
                                        setInvoiceReceiptsData({
                                          ...invoiceReceiptsData,
                                          products: list,
                                        });
                                        validateProduct(list[i], i);
                                      }}
                                    />
                                    {errorsPro[i]?.price && (
                                      <small className="text-danger">
                                        {errorsPro[i].price}
                                      </small>
                                    )}
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("discount")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Discount"
                                      value={product.discount}
                                      onChange={(e) => {
                                        let list = [
                                          ...invoiceReceiptsData.products,
                                        ];
                                        list[i].discount = parseFloat(
                                          e.target.value,
                                        );
                                        setInvoiceReceiptsData({
                                          ...invoiceReceiptsData,
                                          products: list,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </div>
                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("deduction")}
                                    </Label>
                                    <Select
                                      className="my-select-v"
                                      options={deductionList}
                                      value={deductionList.find(
                                        (item) =>
                                          item.value ===
                                          invoiceReceiptsData.products[i]
                                            .deduction_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        let list = [
                                          ...invoiceReceiptsData.products,
                                        ];
                                        list[i].deduction_id = selectedOption
                                          ? selectedOption.value
                                          : null;
                                        setInvoiceReceiptsData({
                                          ...invoiceReceiptsData,
                                          products: list,
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Deduction"}
                                    />
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("order")}
                                    </Label>
                                    <input
                                      type="number"
                                      className="form-control mb-2"
                                      placeholder="Order"
                                      value={product.order}
                                      onChange={(e) => {
                                        let list = [
                                          ...invoiceReceiptsData.products,
                                        ];
                                        list[i].order = parseFloat(
                                          e.target.value,
                                        );
                                        setInvoiceReceiptsData({
                                          ...invoiceReceiptsData,
                                          products: list,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("exemption_reason")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={exemptionList}
                                          value={exemptionList.find(
                                            (item) =>
                                              item.value ===
                                              invoiceReceiptsData.products[i]
                                                .exemption_reason,
                                          )}
                                          onChange={(selectedOption) => {
                                            let list = [
                                              ...invoiceReceiptsData.products,
                                            ];
                                            list[i].exemption_reason =
                                              selectedOption
                                                ? selectedOption.value
                                                : null;
                                            setInvoiceReceiptsData({
                                              ...invoiceReceiptsData,
                                              products: list,
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={
                                            "Select Exemption Reason"
                                          }
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-3">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("warehouse")}
                                    </Label>
                                    <Select
                                      className="my-select-v"
                                      options={warehouseList}
                                      value={warehouseList.find(
                                        (item) =>
                                          item.value ===
                                          invoiceReceiptsData.products[i]
                                            .warehouse_id,
                                      )}
                                      onChange={(selectedOption) => {
                                        let list = [
                                          ...invoiceReceiptsData.products,
                                        ];
                                        list[i].warehouse_id = selectedOption
                                          ? selectedOption.value
                                          : null;
                                        setInvoiceReceiptsData({
                                          ...invoiceReceiptsData,
                                          products: list,
                                        });
                                      }}
                                      isSearchable={true}
                                      isClearable={true}
                                      placeholder={"Select Warehouse"}
                                    />
                                  </FormGroup>
                                </div>
                                <div className="col-md-3"></div>
                                <div className="col-md-3"></div>

                                <div className="row">
                                  <div
                                    className="col-md-12"
                                    style={{
                                      marginTop: "15px",
                                      marginBottom: "15px",
                                    }}
                                  >
                                    {" "}
                                    <h5>{t("tax")}</h5>
                                    <button
                                      className="btn btn-primary"
                                      onClick={(e) => handleAddTax(e, i)}
                                      type="button"
                                    >
                                      + {t("add_tax")}
                                    </button>
                                  </div>
                                  {product?.taxes?.length > 0 ? (
                                    <div
                                      className="row justify-content-start"
                                      style={{
                                        maxHeight: "300px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {product?.taxes?.map((prop, j) => (
                                        <div className="col-md-6">
                                          <div className="fileupload-content px-4">
                                            <div
                                              className="row justify-content-start align-items-center mb-2"
                                              key={j}
                                            >
                                              <div className="col-md-6">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("tax")}
                                                  </Label>
                                                  <Select
                                                    className="my-select-v"
                                                    options={taxDataList}
                                                    value={taxDataList.find(
                                                      (item) =>
                                                        item.value ===
                                                        String(
                                                          invoiceReceiptsData
                                                            .products[i].taxes[
                                                            j
                                                          ].tax_id,
                                                        ),
                                                    )}
                                                    onChange={(
                                                      selectedOption,
                                                    ) => {
                                                      let list = [
                                                        ...invoiceReceiptsData.products,
                                                      ];
                                                      list[i].taxes[j].tax_id =
                                                        selectedOption
                                                          ? selectedOption.value
                                                          : null;
                                                      setInvoiceReceiptsData({
                                                        ...invoiceReceiptsData,
                                                        products: list,
                                                      });
                                                    }}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    placeholder={"Select Tax"}
                                                  />
                                                </FormGroup>
                                              </div>

                                              <div className="col-md-6">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("value")}
                                                  </Label>
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Value"
                                                    value={prop.value}
                                                    onChange={(e) => {
                                                      let list = [
                                                        ...invoiceReceiptsData.products,
                                                      ];
                                                      list[i].properties[
                                                        j
                                                      ].value = e.target.value;
                                                      setInvoiceReceiptsData({
                                                        ...invoiceReceiptsData,
                                                        products: list,
                                                      });
                                                    }}
                                                  />
                                                </FormGroup>
                                              </div>
                                              <div className="col-md-6">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("order")}
                                                  </Label>
                                                  <input
                                                    type="Number"
                                                    className="form-control"
                                                    placeholder="Order"
                                                    value={prop.order}
                                                    onChange={(e) => {
                                                      let list = [
                                                        ...invoiceReceiptsData.products,
                                                      ];
                                                      list[i].taxes[j].order =
                                                        e.target.value;
                                                      setInvoiceReceiptsData({
                                                        ...invoiceReceiptsData,
                                                        products: list,
                                                      });
                                                    }}
                                                  />
                                                </FormGroup>
                                              </div>

                                              <div className="col-md-4 d-flex align-item-center">
                                                <FormGroup>
                                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                    {t("cumulative")}
                                                  </Label>
                                                  <div className="col-xl-12">
                                                    <div className="input-div">
                                                      <div className="form-check">
                                                        <input
                                                          className="my-checkbox-1 form-check-input"
                                                          type="checkbox"
                                                          checked={
                                                            prop.cumulative ===
                                                            1
                                                          }
                                                          onChange={(e) => {
                                                            let list = [
                                                              ...invoiceReceiptsData.products,
                                                            ];
                                                            list[i].taxes[
                                                              j
                                                            ].cumulative = e
                                                              .target.checked
                                                              ? 1
                                                              : 0;
                                                            setInvoiceReceiptsData(
                                                              {
                                                                ...invoiceReceiptsData,
                                                                products: list,
                                                              },
                                                            );
                                                          }}
                                                        />
                                                        <label className="form-check-label pl-2">
                                                          {t("Cumulative")}
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </FormGroup>
                                              </div>

                                              <div className="d-flex align-item-center">
                                                <button
                                                  className="btn btn-danger"
                                                  onClick={(e) =>
                                                    handleRemoveTax(e, i, j)
                                                  }
                                                >
                                                  <i className="bi bi-trash"></i>
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  ) : (
                                    <p className="text-muted">
                                      No tax list added.
                                    </p>
                                  )}
                                </div>
                              </div>

                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={(e) => handleRemoveProduct(e, i)}
                              >
                                <i className="bi bi-trash"></i>
                              </button>
                            </div>
                          ))}
                        </div>

                        <div className="row">
                          <div className="col ms-2">
                            <button
                              type="button"
                              className="back-btn"
                              onClick={() => navigate("/paymentReturns")}
                            >
                              <i className="bi bi-arrow-left"> </i> {t("back")}
                            </button>
                          </div>
                          <div className="col">
                            <div className="d-flex justify-content-end nxt-btn">
                              {btnLoader === true ? (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  Loading...
                                </button>
                              ) : (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  {t("submit")} <i className="bi bi-check2"></i>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>

          <Modal isOpen={customerModel} size="xl">
            <ModalHeader>{t("CreateCustomer")}</ModalHeader>
            <Form method={`post`}>
              <ModalBody>
                <div className="row">
                  <div className="mb-3">
                    {/* Tabs */}
                    <ul className="custom-tabs">
                      <li
                        className={
                          activeCustomerTab === "1"
                            ? "tab-item active"
                            : "tab-item"
                        }
                        onClick={() => setActiveCustomerTab("1")}
                      >
                        {t("main")}
                      </li>

                      <li
                        className={
                          activeCustomerTab === "2"
                            ? "tab-item active"
                            : "tab-item"
                        }
                        onClick={() => setActiveCustomerTab("2")}
                      >
                        {t("contact")}
                      </li>

                      <li
                        className={
                          activeCustomerTab === "3"
                            ? "tab-item active"
                            : "tab-item"
                        }
                        onClick={() => setActiveCustomerTab("3")}
                      >
                        {t("otherAddresses")}
                      </li>

                      <li
                        className={
                          activeCustomerTab === "4"
                            ? "tab-item active"
                            : "tab-item"
                        }
                        onClick={() => setActiveCustomerTab("4")}
                      >
                        {t("billingSettings")}
                      </li>
                    </ul>

                    <div className="tab-content-area">
                      {activeCustomerTab === "1" && (
                        <div className="row">
                          <div class="alert alert-light" role="alert">
                            NOTE: All required fields are marked with{" "}
                            <span style={{ color: "red" }}>(*)</span>
                          </div>

                          <p>General Information</p>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("vat")}{" "}
                                <span className="text-danger">*</span>
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={customerData.vat}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      vat: e.target.value,
                                    });
                                  }}
                                  name={`vat`}
                                  maxLength={50}
                                  placeholder="Vat"
                                />
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("number")}
                                <span className="text-danger">*</span>
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={customerData.number}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      number: e.target.value,
                                    });
                                  }}
                                  name={`number`}
                                  maxLength={50}
                                  placeholder="Number"
                                />
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("Name")}{" "}
                                <span className="text-danger">*</span>
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={customerData.name}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      name: e.target.value,
                                    });
                                  }}
                                  name={`name`}
                                  maxLength={50}
                                  placeholder="Name"
                                />
                              </div>
                              {errors.name && (
                                <span className="input-error">
                                  {errors.name}
                                </span>
                              )}
                            </FormGroup>
                          </div>
                          <div class="alert alert-primary" role="alert">
                            Fill with default data
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("address")}
                              </Label>
                              <span className="text-danger">*</span>

                              <div className="col-xl-12">
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={customerData.address}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      address: e.target.value,
                                    });
                                  }}
                                  name={`address`}
                                  maxLength={50}
                                  placeholder="Address"
                                  rows={3}
                                />
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("city")}
                              </Label>
                              <span className="text-danger">*</span>

                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={customerData.city}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      city: e.target.value,
                                    });
                                  }}
                                  name={`city`}
                                  maxLength={50}
                                  placeholder="City"
                                />
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("zip_code")}
                              </Label>
                              <span className="text-danger">*</span>

                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={customerData.zip_code}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      zip_code: e.target.value,
                                    });
                                  }}
                                  name={`zip_code`}
                                  maxLength={50}
                                  placeholder="Zip code"
                                />
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("country")}
                              </Label>
                              <span className="text-danger">*</span>

                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    className="my-select-v"
                                    options={countryList}
                                    value={countryList.find(
                                      (item) =>
                                        item.value == customerData.country_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setCustomerData({
                                        ...customerData,
                                        country_id: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Country"}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("email")}
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={customerData.email}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      email: e.target.value,
                                    });
                                  }}
                                  name={`email`}
                                  maxLength={50}
                                  placeholder="Contact email"
                                />
                                {errors.email && (
                                  <span className="input-error">
                                    {errors.email}
                                  </span>
                                )}
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4" />
                        </div>
                      )}

                      {activeCustomerTab === "2" && (
                        <div className="row">
                          <div class="alert alert-light" role="alert">
                            NOTE: All required fields are marked with{" "}
                            <span style={{ color: "red" }}>(*)</span>
                          </div>

                          <p>Contacts</p>
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("phone")}
                              </Label>
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={customerData.phone}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      phone: e.target.value,
                                    });
                                  }}
                                  name={`phone`}
                                  placeholder="Phone"
                                />
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("fax")}
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={customerData.fax}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      fax: e.target.value,
                                    });
                                  }}
                                  name={`fax`}
                                  placeholder="Fax"
                                />
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("website")}
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={customerData.website}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      website: e.target.value,
                                    });
                                  }}
                                  name={`website`}
                                  placeholder="website"
                                />
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("contactPerson")}
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={customerData.contact_person}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      contact_person: e.target.value,
                                    });
                                  }}
                                  name={`contact_person`}
                                  placeholder="Contact Person"
                                />
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("contactEmail")}
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={customerData.contact_email}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      contact_email: e.target.value,
                                    });
                                  }}
                                  name={`contact_email`}
                                  placeholder="Contact Email"
                                />
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("telephoneContact")}
                              </Label>
                              <div className="col-xl-12">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={customerData.telephone_contact}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      telephone_contact: e.target.value,
                                    });
                                  }}
                                  name={`telephone_contact`}
                                  placeholder="Telephone Contact"
                                />
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-12">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("contactNotes")}
                              </Label>
                              <div className="col-xl-12">
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={customerData.contact_notes}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      contact_notes: e.target.value,
                                    });
                                  }}
                                  name={`contact_notes`}
                                  placeholder="Contact Notes"
                                  rows={4}
                                />
                              </div>
                            </FormGroup>
                          </div>
                        </div>
                      )}

                      {activeCustomerTab === "3" && (
                        <>
                          <div className="row">
                            <div className="alert alert-light" role="alert">
                              NOTE: All required fields are marked with{" "}
                              <span style={{ color: "red" }}>(*)</span>
                            </div>

                            <p>Alternate Address</p>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  Description
                                </Label>
                                <span className="text-danger">*</span>

                                <input
                                  className="form-control input-search"
                                  type="text"
                                  name="description"
                                  value={altForm.description}
                                  onChange={handleAltChange}
                                  placeholder="Description"
                                />
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  Code
                                </Label>
                                <span className="text-danger">*</span>

                                <input
                                  className="form-control input-search"
                                  type="text"
                                  name="code"
                                  value={altForm.code}
                                  onChange={handleAltChange}
                                  placeholder="Code"
                                />
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  Zip Code
                                </Label>
                                <span className="text-danger">*</span>

                                <input
                                  className="form-control input-search"
                                  type="text"
                                  name="zip_code"
                                  value={altForm.zip_code}
                                  onChange={handleAltChange}
                                  placeholder="Zip Code"
                                />
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  City
                                </Label>
                                <span className="text-danger">*</span>

                                <input
                                  className="form-control input-search"
                                  type="text"
                                  name="city"
                                  value={altForm.city}
                                  onChange={handleAltChange}
                                  placeholder="City"
                                />
                              </FormGroup>
                            </div>

                            {/* Country */}
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  Country
                                </Label>
                                <span className="text-danger">*</span>

                                <Select
                                  className="my-select-v"
                                  options={countryList}
                                  value={
                                    countryList.find(
                                      (item) => item.value === altForm.country,
                                    ) || null
                                  }
                                  onChange={(selectedOption) => {
                                    setAltForm({
                                      ...altForm,
                                      country: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder="Select Country"
                                />
                              </FormGroup>
                            </div>

                            {/* Email */}
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  E-mail
                                </Label>
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  name="email"
                                  value={altForm.email}
                                  onChange={handleAltChange}
                                  placeholder="Email"
                                />
                              </FormGroup>
                            </div>

                            {/* Phone */}
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  Phone
                                </Label>
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  name="phone"
                                  value={altForm.phone}
                                  onChange={handleAltChange}
                                  placeholder="Phone"
                                />
                              </FormGroup>
                            </div>

                            {/* Fax */}
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  Fax
                                </Label>
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  name="fax"
                                  value={altForm.fax}
                                  onChange={handleAltChange}
                                  placeholder="Fax"
                                />
                              </FormGroup>
                            </div>

                            {/* Contact Person */}
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  Contact Person
                                </Label>
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  name="contact_person"
                                  value={altForm.contact_person}
                                  onChange={handleAltChange}
                                  placeholder="Contact Person"
                                />
                              </FormGroup>
                            </div>

                            <div className="col-md-12">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  Address
                                </Label>
                                <span className="text-danger">*</span>

                                <textarea
                                  className="form-control input-search"
                                  rows={4}
                                  name="address"
                                  value={altForm.address}
                                  onChange={handleAltChange}
                                  placeholder="Address"
                                />
                              </FormGroup>
                            </div>

                            <div className="col-md-12 mt-3">
                              <button
                                className="btn btn-primary"
                                onClick={saveAlternateAddress}
                                type="button"
                              >
                                {editIndex !== null
                                  ? "Update Address"
                                  : "Add Address"}
                              </button>
                            </div>
                          </div>

                          <div>
                            {invoiceReceiptsData?.alternate_address?.length >
                              0 && (
                              <table className="table table-bordered mt-4">
                                <thead>
                                  <tr>
                                    <th>Code</th>
                                    <th>City</th>
                                    <th>Country</th>
                                    <th>Email</th>
                                    <th style={{ width: "120px" }}>Actions</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {invoiceReceiptsData?.alternate_address?.map(
                                    (item, index) => (
                                      <tr key={index}>
                                        <td>{item.code}</td>
                                        <td>{item.city}</td>
                                        <td>{item.country}</td>
                                        <td>{item.email}</td>
                                        <td>
                                          <div className="d-flex gap-2">
                                            <button
                                              className="btn btn-sm"
                                              type="button"
                                              onClick={() =>
                                                editAlternateAddress(index)
                                              }
                                            >
                                              <i className="bi bi-pencil"></i>
                                            </button>

                                            <button
                                              className="btn btn-sm"
                                              type="button"
                                              onClick={() =>
                                                deleteAlternateAddress(index)
                                              }
                                            >
                                              <i className="bi bi-trash3"></i>
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    ),
                                  )}
                                </tbody>
                              </table>
                            )}
                          </div>
                        </>
                      )}

                      {activeCustomerTab === "4" && (
                        <div className="row">
                          <div className="alert alert-light" role="alert">
                            NOTE: All required fields are marked with{" "}
                            <span style={{ color: "red" }}>(*)</span>
                          </div>

                          <p>Billing Settings</p>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("language")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    className="my-select-v"
                                    options={languageList}
                                    value={languageList.find(
                                      (item) =>
                                        item.value == customerData.language_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setCustomerData({
                                        ...customerData,
                                        language_id: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Language"}
                                  />
                                  {errors.language_id && (
                                    <span className="input-error">
                                      {errors.language_id}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("PriceTablesByDefault")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    className="my-select-v"
                                    options={priceClassList}
                                    value={priceClassList.find(
                                      (item) =>
                                        item.value ==
                                        customerData.price_class_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setCustomerData({
                                        ...customerData,
                                        price_class_id: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={
                                      "Select Price Tables By Default"
                                    }
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("Maturity")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    className="my-select-v"
                                    options={maturityDatesList}
                                    value={maturityDatesList.find(
                                      (item) =>
                                        item.value ==
                                        customerData.maturity_date_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setCustomerData({
                                        ...customerData,
                                        maturity_date_id: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Maturity"}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("payment_day")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="number"
                                    value={customerData.payment_day}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        payment_day: e.target.value,
                                      });
                                    }}
                                    name={`payment_day`}
                                    maxLength={50}
                                    placeholder="Payment day"
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("globalDiscount")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="number"
                                    value={customerData.global_discount_id}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        global_discount_id: e.target.value,
                                      });
                                    }}
                                    name={`global_discount_id`}
                                    maxLength={50}
                                    placeholder="Global Discount"
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("credit_limit")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="number"
                                    value={customerData.credit_limit}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        credit_limit: e.target.value,
                                      });
                                    }}
                                    name={`credit_limit`}
                                    maxLength={50}
                                    placeholder="Credit limit"
                                  />
                                  {errors.credit_limit && (
                                    <span className="input-error">
                                      {errors.credit_limit}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("paymentMethod")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    className="my-select-v"
                                    options={paymentMethodList}
                                    value={paymentMethodList.find(
                                      (item) =>
                                        item.value ==
                                        customerData.payment_method_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setCustomerData({
                                        ...customerData,
                                        payment_method_id: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Payment Method"}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("deliveryMethod")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    className="my-select-v"
                                    options={deliveryMethodList}
                                    value={deliveryMethodList.find(
                                      (item) =>
                                        item.value ==
                                        customerData.delivery_method_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setCustomerData({
                                        ...customerData,
                                        delivery_method_id: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Payment Method"}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("salesmen")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <Select
                                    className="my-select-v"
                                    options={salesmenList}
                                    value={salesmenList.find(
                                      (item) =>
                                        item.value === customerData.salesman_id,
                                    )}
                                    onChange={(selectedOption) => {
                                      setCustomerData({
                                        ...customerData,
                                        salesman_id: selectedOption
                                          ? selectedOption.value
                                          : "",
                                      });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder={"Select Salesmen"}
                                  />
                                  {errors.salesman_id && (
                                    <span className="input-error">
                                      {errors.salesman_id}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my">
                                {t("notes")}
                              </Label>
                              <div className="col-xl-12">
                                <div className="input-div">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    value={customerData.notes}
                                    onChange={(e) => {
                                      setCustomerData({
                                        ...customerData,
                                        notes: e.target.value,
                                      });
                                    }}
                                    name={`notes`}
                                    maxLength={50}
                                    placeholder="notes"
                                  />
                                </div>
                                {errors.notes && (
                                  <span className="input-error">
                                    {errors.notes}
                                  </span>
                                )}
                              </div>
                            </FormGroup>
                          </div>

                          <div className="col-md-4" />
                          <div className="col-md-4" />
                          <div className="col-md-4" />
                          <div className="col-md-4" />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <button
                  type="button"
                  className="btn btn-block btn-primary"
                  disabled={isModifyButtonLoad}
                  onClick={handleCustomerCloseModel}
                  style={{ width: "100px", marginTop: "10px" }}
                >
                  {t("close")} <i className="bi bi-x-lg"></i>
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ width: "120px" }}
                  disabled={isModifyButtonLoad}
                  onClick={handleCustomerSubmit}
                >
                  {isModifyButtonLoad ? (
                    <>
                      <i className="fa fa-circle-o-notch fa-spin"></i>{" "}
                      Loading...
                    </>
                  ) : (
                    <>
                      {t("submit")} <i className="bi bi-check2"></i>
                    </>
                  )}
                </button>
              </ModalFooter>
            </Form>
          </Modal>
        </section>
      </div>
    </div>
  );
};

export default AddPaymentReturns;
